import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupRetailSettings } from "../../../Shared/NewForms/NFLookupRetailSettings";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PosTerminalDetailMain = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFDateInput fieldName={"createdDate"} title={t("CreatedDate")} disabled />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("uniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFLookupAccount title={t("accountId")} fieldName={"accountId"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupRetailSettings title={t("retailSettingId")} fieldName={"retailSettingId"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("posTerminalNumber")} fieldName={"posTerminalNumber"} />
        </Col>
      </Row>
    </>
  );
};

export default PosTerminalDetailMain;
